import { slugify } from "@lib/util/slugify"

const normalizeString = (value: unknown): string => {
  if (typeof value !== "string") return ""
  return value.trim()
}

export const resolveProductBrandSlug = (
  product: any,
  fallbackBrandSlug?: string | null,
): string => {
  const explicitBrandSlug =
    normalizeString(product?.brand?.slug) ||
    normalizeString(product?.brandSlug) ||
    normalizeString(fallbackBrandSlug)
  if (explicitBrandSlug) {
    return slugify(explicitBrandSlug)
  }

  const brandName = normalizeString(product?.brand?.name)
  if (!brandName) return ""

  return slugify(brandName)
}

export const resolveProductHref = (
  product: any,
  fallbackBrandSlug?: string | null,
): string => {
  const productSlug = normalizeString(product?.slug)
  if (!productSlug) return "/store"

  const brandSlug = resolveProductBrandSlug(product, fallbackBrandSlug)
  if (brandSlug) {
    return `/${brandSlug}/products/${productSlug}`
  }

  return `/products/${productSlug}`
}

export const resolveCartItemProductHref = (item: any): string => {
  const productSlug =
    normalizeString(item?.productSlug) ||
    normalizeString(item?.product_slug) ||
    normalizeString(item?.product_handle) ||
    normalizeString(item?.product?.slug) ||
    normalizeString(item?.variant?.product?.slug)
  if (!productSlug) return "/store"

  const brandSlug =
    normalizeString(item?.brandSlug) ||
    normalizeString(item?.brand_slug) ||
    normalizeString(item?.product?.brandSlug) ||
    normalizeString(item?.variant?.product?.brandSlug)
  const brandName =
    normalizeString(item?.brandName) ||
    normalizeString(item?.brand_name) ||
    normalizeString(item?.brand?.name) ||
    normalizeString(item?.product?.brand?.name) ||
    normalizeString(item?.variant?.product?.brand?.name)

  return resolveProductHref(
    {
      slug: productSlug,
      brandSlug,
      brand: {
        slug:
          normalizeString(item?.brand?.slug) ||
          normalizeString(item?.product?.brand?.slug) ||
          normalizeString(item?.variant?.product?.brand?.slug),
        name: brandName,
      },
    },
    brandSlug,
  )
}
